import {
  BillingPeriods,
  CumulativeUsageSummary,
  InstitutionDailyUsageSummary,
} from './types';

export enum ActionTypes {
  INSTITUTION_CUMULATIVE_USAGE_LOAD_START = 'INSTITUTION_CUMULATIVE_USAGE_LOAD_START',
  INSTITUTION_CUMULATIVE_USAGE_LOAD_SUCCESS = 'INSTITUTION_CUMULATIVE_USAGE_LOAD_SUCCESS',
  INSTITUTION_CUMULATIVE_USAGE_LOAD_FAIL = 'INSTITUTION_CUMULATIVE_USAGE_LOAD_FAIL',
  DAILY_USAGE_SUMMARY_LOAD_START = 'DAILY_USAGE_SUMMARY_LOAD_START',
  DAILY_USAGE_SUMMARY_LOAD_SUCCESS = 'DAILY_USAGE_SUMMARY_LOAD_SUCCESS',
  DAILY_USAGE_SUMMARY_LOAD_FAIL = 'DAILY_USAGE_SUMMARY_LOAD_FAIL',
  BILLING_PERIODS_LOAD = 'BILLING_PERIODS_LOAD',
  BILLING_PERIODS_LOAD_FAIL = 'BILLING_PERIODS_LOAD_FAIL',
}

export type InstitutionCumulativeUsageLoadStarted = {
  type: ActionTypes.INSTITUTION_CUMULATIVE_USAGE_LOAD_START;
};

export type InstitutionCumulativeUsageLoadSucceeded = {
  type: ActionTypes.INSTITUTION_CUMULATIVE_USAGE_LOAD_SUCCESS;
  data: CumulativeUsageSummary;
};

export type InstitutionCumulativeUsageLoadFailed = {
  type: ActionTypes.INSTITUTION_CUMULATIVE_USAGE_LOAD_FAIL;
  error: string;
};

export type DailyUsageSummaryLoadStarted = {
  type: ActionTypes.DAILY_USAGE_SUMMARY_LOAD_START;
};

export type DailyUsageSummaryLoadSucceeded = {
  type: ActionTypes.DAILY_USAGE_SUMMARY_LOAD_SUCCESS;
  data: InstitutionDailyUsageSummary;
};

export type DailyUsageSummaryLoadFailed = {
  type: ActionTypes.DAILY_USAGE_SUMMARY_LOAD_FAIL;
  error: string;
};

export type BillingPeriodsLoad = {
  type: ActionTypes.BILLING_PERIODS_LOAD;
  data: BillingPeriods;
};

export type BillingPeriodsLoadFail = {
  type: ActionTypes.BILLING_PERIODS_LOAD_FAIL;
};

export type InstitutionUsageAction =
  | InstitutionCumulativeUsageLoadStarted
  | InstitutionCumulativeUsageLoadSucceeded
  | InstitutionCumulativeUsageLoadFailed
  | DailyUsageSummaryLoadStarted
  | DailyUsageSummaryLoadSucceeded
  | DailyUsageSummaryLoadFailed
  | BillingPeriodsLoad;
